<template>
  <div>
    <v-alert
      v-model="$store.state.alert.display"
      class="defaultAlert"
      transition="scale-transition"
      color="blue"
      dark
      dismissible
      outlined
      max-width="600px"
      width="520px"
    >
      <v-icon color="blue">mdi-account</v-icon>
      <p style="margin-bottom: 0px;display:inline-flex;margin-left: 4px;" v-html="$store.state.alert.msg"></p>
    </v-alert>
  </div>
</template>
<style scoped>
.defaultAlert {
  text-align: left;
  margin: 30px;
  position: fixed;
  right: 8px;
  bottom: 8px;
  z-index: 1000;
  background: white !important;
  border: thin solid currentColor !important;
  white-space: pre-line;
}
</style>
<script>
export default {};
</script>
